import React from 'react';
import styles from './styles/XVStack.module.scss';


export interface IVStackProps {
    children? : React.ReactNode;
    height?: string;
    width?: string;
    padding?: string;
    //name:string;
    //optionalParam?:number;
}
export interface IVStackState {

}
export class XVStack extends React.Component<IVStackProps, IVStackState> {
    // constructor(props: IVStackProps) {
    //     super(props)
    // }
    render() :React.ReactNode
    {
        return (<div className={styles.XVStack} style={{height: this.props.height, width: this.props.width, padding: this.props.padding}}>{this.props.children}</div>);
    }
}